import ReactDOM from 'react-dom/client'
import App from './index.loader'
import './index.scss'

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)
